import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card'
import { CheckCircle2, Calendar, Users, BookOpen, ArrowRight } from 'lucide-react'
import Confetti from 'react-confetti'
import { useWindowSize } from 'react-use'

function OnboardingComplete({ facility, onGoToDashboard }) {
  const { width, height } = useWindowSize()

  const nextSteps = [
    {
      icon: BookOpen,
      title: 'Create Your First Class',
      description: 'Set up class schedules for students to register'
    },
    {
      icon: Users,
      title: 'Add Coaches',
      description: 'Invite coaches and assign them to classes'
    },
    {
      icon: Calendar,
      title: 'Share Your Registration Link',
      description: 'Let parents know they can register their kids'
    }
  ]

  return (
    <div className="min-h-[80vh] px-4 py-8 relative">
      <Confetti width={width} height={height} recycle={false} numberOfPieces={200} gravity={0.1} />

      <div className="flex items-center justify-center">
        <Card className="w-full max-w-2xl">
          <CardHeader className="space-y-1 text-center">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle2 className="w-10 h-10 text-green-600" />
            </div>
            <CardTitle className="text-3xl font-bold">Welcome to Leevo, {facility?.name}!</CardTitle>
            <CardDescription className="text-lg">Your facility is all set up and ready to go</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4">
              <h3 className="font-medium text-gray-900">Here&apos;s what to do next:</h3>
              <div className="space-y-3">
                {nextSteps.map((step, index) => (
                  <div key={`${index}-${step.title}`} className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="flex-shrink-0 w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                      <step.icon className="w-4 h-4 text-purple-600" />
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">{step.title}</p>
                      <p className="text-sm text-gray-600">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="pt-4">
              <Button onClick={onGoToDashboard} className="w-full bg-purple-600 hover:bg-purple-700 h-12 text-lg">
                Go to Your Dashboard
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </div>

            <p className="text-xs text-center text-gray-500">
              Need help? Chat with us anytime using the chat icon in the bottom right corner.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

OnboardingComplete.propTypes = {
  facility: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }),
  onGoToDashboard: PropTypes.func.isRequired
}

export default OnboardingComplete
